// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const venuesExportFields = [
  {
    titleIntlKey: "venues.columns.address.title",
    fields: [
      "addressAddress1",
      "addressAddress2",
      "addressAddress3",
      "addressCity",
      "addressCountryCode",
      "addressLatitude",
      "addressLongitude",
      "addressPostalCode",
      "addressState",
    ],
  },
  {
    titleIntlKey: "venues.columns.venue.title",
    fields: [
      "venueId",
      "forceVenueId",
      "externalId",
      "abbreviationLatin",
      "abbreviationLocal",
      "alternateNameLatin",
      "alternateNameLocal",
      "capacity",
      "countryCode",
      "nameLatin",
      "nameLocal",
      "status",
      "timezone",
    ],
  },
  {
    titleIntlKey: "venues.columns.site.title",
    fields: ["siteId", "siteExternalId", "siteName"],
  },
  {
    titleIntlKey: "venues.columns.social.title",
    fields: ["socialFacebook", "socialInstagram", "socialTwitter", "socialWebsite", "socialWikipedia"],
  },
];

export const defaultVenuesExportFieldNames = ["venueId", "nameLocal", "timezone", "countryCode", "status"];
